import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { AnnouncementByKind, AnnouncementKind, AnnouncementMode, BaseViewComponent, IAnnouncement, StatusKind, StorageBaseKeys } from '@sb/library/base';
import { AnnouncementService } from './announcement.service';

@Component({
    selector: 'lib-announcement',
    templateUrl: './announcement.component.html',
    styleUrls: ['./announcement.component.scss']
})
export class AnnouncementComponent extends BaseViewComponent implements OnInit {
    @Input() announcementTextTemplate?: TemplateRef<any>;
    @Input() announcementTitleTemplate?: TemplateRef<any>;
    @Input() announcementButtonGroupTemplate?: TemplateRef<any>;

    readonly AnnouncementMode = AnnouncementMode;

    private readonly kindOrder: Partial<Record<StatusKind, number>> = {
        [StatusKind.Danger]: 1,
        [StatusKind.Warning]: 2,
        [StatusKind.Brand]: 3,
        [StatusKind.Light]: 4
    };

    constructor(private _AnnouncementService: AnnouncementService) {
        super();
    }

    OrderAnnouncements(announcements: AnnouncementKind[]): AnnouncementKind[] {
        return announcements
            .filter(announcement => Object.values(AnnouncementKind).includes(announcement))
            .orderBy(
                announcement => this.kindOrder[AnnouncementByKind[announcement].Kind]!,
                undefined,
                announcement => AnnouncementByKind[announcement].Priority
            );
    }

    GetAnnouncementByKind(kind: AnnouncementKind): IAnnouncement {
        return AnnouncementByKind[kind];
    }

    DismissClicked(kind: AnnouncementKind): void {
        this._AnnouncementService.dismissSubject.next(kind);
    }

    get hasAnnouncements(): boolean {
        return this.OrderAnnouncements(this.announcements).length > 0;
    }

    get announcements(): AnnouncementKind[] {
        return this._AnnouncementService.announcements;
    }
}
